export default __webpack_public_path__ + "static/media/success-text.202126b4.png";